import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ menuItems }) => {
  const [hoverItem, setHoverItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  const handleItems = (route) => {
    navigate(route);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="min-w-[280px] w-[280px] max-w-[280px] bg-white h-screen p-2">
      <div className="flex flex-col h-full justify-between">
        <div>
          <div className="flex justify-center items-center py-6">
            <h2 className="text-5xl font-semibold">LOGO</h2>
          </div>
          <div className="py-10">
            <ul>
              {menuItems.map((val, index) => {
                const isHovered = hoverItem === val.key;
                const isActive = location.pathname === val.route; // Check if the route is active

                return (
                  <li
                    key={index}
                    onClick={() => handleItems(val.route)}
                    onMouseEnter={() => setHoverItem(val.key)}
                    onMouseLeave={() => setHoverItem("")}
                    className={`cursor-pointer my-1 pl-8 flex gap-2.5 items-center rounded-[10px] h-[50px] 
                      ${isActive ? "bg-primary text-white" : ""}
                      ${
                        isHovered && !isActive
                          ? "hover:bg-primary hover:text-white"
                          : ""
                      }
                    `}
                  >
                    <val.img
                      color={isActive || isHovered ? "white" : "#013941"}
                    />
                    <p className="text-lg font-normal">{val.title}</p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div
          className="pl-8 mb-4 flex gap-2.5 items-center rounded-[10px] cursor-pointer"
          onClick={handleLogout}
        >
          <img src="/images/logout.svg" alt="" />
          <p className="text-[#F62C2C] text-lg font-normal">Logout</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
